import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Hint from 'modules/contracts/components/FlowPage/FormWrapper/Hint'

const MaximumHoursHint = () => {
  return (
    <Hint color="viridian100">
      <Text.Normal color="grey1000" weight="normal" size="100">
        {i18n.t('contract_versions.flows.update.steps.work_hours.hints.max_hours')}
      </Text.Normal>
    </Hint>
  )
}

export default observer(MaximumHoursHint)
